"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegacyFormFieldSelect = void 0;
const react_1 = __importDefault(require("react"));
const classFunctions_1 = require("../../../../utils/classFunctions");
const legacy_1 = require("../../../SelectBox/legacy");
const Wrapper_1 = require("../Wrapper");
require("./index.scss");
const className = 'form-field-select';
/** @deprecated Use FormFieldSelect */
const LegacyFormFieldSelect = (props) => {
    const { label, withBadge = false, error, placeholder = '', modificators, items, value, required, ...otherProps } = props;
    const valueClassNames = (0, classFunctions_1.getClassNames)(`${className}__badge`, [
        !value ? 'hidden' : undefined,
        otherProps.disabled ? 'disabled' : undefined,
    ]);
    const selectBoxModifiers = value && withBadge
        ? `${className}-airport`
        : undefined;
    return (react_1.default.createElement(Wrapper_1.FormFieldWrapper, { label: label, error: error, modificators: modificators, required: required, slot: react_1.default.createElement(react_1.default.Fragment, null,
            withBadge && value && (react_1.default.createElement("p", { className: valueClassNames }, value)),
            react_1.default.createElement("div", { className: `${className}__input` },
                react_1.default.createElement(legacy_1.LegacySelectBox, { placeholder: placeholder, items: items, value: value, ...otherProps, modificators: selectBoxModifiers }))) }));
};
exports.LegacyFormFieldSelect = LegacyFormFieldSelect;
//# sourceMappingURL=legacy.js.map